import React, { useEffect, useState } from "react";
import { Button, HStack, useToast } from "@chakra-ui/react";
import { GET_PREDICTED_URL_DATA, UPDATE_PREDICTED_CORRECTIONS_TABLE } from "../../../graphql/operations/campaignOperations/operations";
import { useMutation, useQuery } from "@apollo/client";
import { ToastNotificationBox } from "../../../components/toastNotificationBox/ToastNotificationBox";
import { FaUndo } from "react-icons/fa";



interface CorrectionButtonsProps {
  urlQuery: string;
  onClickAccept?: () => void;
  onClickReject?: () => void;
  // isApproved: boolean;
  predictedFromUrl: string;
  originalclassification: string;
  // content: string;
}


export const CorrectionButtons = ({
  urlQuery,
  // onClickAccept,
  // onClickReject,
  // isApproved,
  predictedFromUrl,
  originalclassification,
  // content,
}: CorrectionButtonsProps) => {
  const toast = useToast();
  const toastId = "url-corrections-toast";

  const [isPredictionsAccepted, setIsPredictionsAccepted] = useState(false)

  const [updatePredictedCorrectionTable, { error: predictionAddingError }] =
    useMutation(UPDATE_PREDICTED_CORRECTIONS_TABLE, {});
  if (predictionAddingError) {
    return <></>;
  }

  const { data, error, loading, refetch } = useQuery(GET_PREDICTED_URL_DATA, {
    variables: { 
      url: urlQuery 
    },
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (data && data?.predictiveCorrectionsStatus) {
      setIsPredictionsAccepted(data.predictiveCorrectionsStatus.isApproved)
    }
  },[data])

  const handleButtonClickAccept = () => {
    onClickFunction(true, predictedFromUrl, urlQuery, "Predicted corrections accepted", originalclassification)
    
  }

  const handleButtonClickReject = () => {
    onClickFunction(false, predictedFromUrl, urlQuery, "Removed Correction", originalclassification)
  }

  if (error) {
    return <> Error </>;
  }

  // create function for onclick functionality
const onClickFunction = (
  isApproved: boolean,
  predictedFromUrl: string,
  url: string,
  content: string,
  originalClassification: string
) => {
  
    updatePredictedCorrectionTable({
      variables: {
        isApproved: isApproved,
        originalClassification: originalClassification,
        predictedFromUrl: predictedFromUrl,
        url: url,
      },
    })
      .then(() => {
        toast({
          id: toastId,
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "bottom-right",
          render: () => {
            return (
              <ToastNotificationBox
                content={content}
                borderLeftColor={"submitGreen.default"}
                backgroundColor={"submitGreen.light"}
                borderColor={"submitGreen.light"}
                borderLeftWidth={4}
                borderRadius={0}
              />
            );
          },
        });
      })
      .then(() => {
        refetch()
      })
      .catch((err) => err);
  } 
  
  return (
    <>
      <HStack align="center" width="100%" justify={"flex-end"} >
          <Button
            // leftIcon={<Icon as={RiCheckFill} w={4} h={4} />}
            variant="blueButton"
            fontSize={["sm", null, null, "sm", null]}
            justify={"flex-end"}
            onClick={handleButtonClickAccept}
            isLoading={loading}
            isDisabled={isPredictionsAccepted}
          >
            Accept
          </Button>

          <Button
            // leftIcon={<Icon as={FaUndo} w={4} h={4} />}
            justify={"flex"}
            fontSize={["sm", null, null, "sm", null]}
            variant="whiteBoxButton"
            isLoading={loading}
            onClick={handleButtonClickReject}
            isDisabled={!isPredictionsAccepted}
          >
            <FaUndo />
            
          </Button>
      </HStack>
    </>
  );
};

